module.exports = __webpack_public_path__ + "static/img/app.0b0b582.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app.png
// module id = /5Ul
// module chunks = 1